import { render, staticRenderFns } from "./MensagemCreate.vue?vue&type=template&id=00fcd2db&"
import script from "./MensagemCreate.vue?vue&type=script&lang=js&"
export * from "./MensagemCreate.vue?vue&type=script&lang=js&"
import style0 from "./MensagemCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports